import styled from '@emotion/styled'

export const LottieWrapper = styled.div({
  svg: {
    stroke: 'transparent',
    strokeWidth: '0px',
    transform: 'none!important',
  },
})
